/* eslint @typescript-eslint/no-explicit-any: 0 */
import i18next from "i18next"

export default class LocalizedError extends Error {
  constructor(key: string, params?: Record<string, any>) {
    super(i18next.t(key, params))
  }
}
